import React, { memo } from 'react';
import cc from 'classcat';
import { type List, LiveShape } from 'lib/LobbyEntities';
import BaseRowList from 'components/RowList';
import Builder, { type Mapping } from '../../../../../Builder';

interface GamesListProps {
  list: List;
  mapping: Mapping;
  trackSectionScrolled: () => void;
}

export const GamesList = ({ list, mapping, trackSectionScrolled }: GamesListProps) => (
  <BaseRowList
    className={cc([
      'dynamicLobby__rowListContent',
      { 'dynamicLobby__rowListContent--live-wide': list.contentShape === LiveShape.liveWide }
    ])}
    scrollEventOnce={trackSectionScrolled}
  >
    {list.children.map(({ __access }, index) => (
      <Builder key={__access} accessRef={__access} mapping={mapping} position={index + 1} />
    ))}
  </BaseRowList>
);

export default memo(GamesList);
